var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 107,
    viewBox: "0 0 100 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.681064 95.8391C-2.16842 101.987 4.46424 108.537 10.5574 105.567C12.5977 104.57 13.6421 102.839 14.555 100.873C16.0973 97.5631 17.6397 94.2467 19.182 90.9372C24.5628 79.3819 29.9505 67.8265 35.3314 56.2711C39.1422 48.0875 42.9531 39.9038 46.7639 31.7202C47.4417 30.2732 48.5275 29.0893 50.2773 29.2485C52.041 29.4078 52.781 30.7302 53.445 32.1564C57.4702 40.7901 61.4885 49.4306 65.5138 58.0643C70.8324 69.4743 76.144 80.8843 81.4626 92.2943C82.8666 95.3129 84.2706 98.3247 85.6746 101.343C86.6567 103.448 88.0538 105.165 90.3361 105.927C96.3878 107.962 101.99 101.53 99.3134 95.7837C96.5469 89.8502 93.7804 83.9099 91.0208 77.9764C85.5639 66.2618 80.107 54.554 74.657 42.8394C69.8503 32.5233 65.0504 22.2142 60.2436 11.8981C59.1301 9.50951 58.0166 7.1209 56.9031 4.73227C56.087 2.98062 54.925 1.52667 53.1407 0.688921C50.7546 -0.432692 47.8705 -0.16959 45.7265 1.36744C44.2533 2.42674 43.4925 3.92914 42.7456 5.52848C39.1353 13.2759 35.5319 21.0164 31.9217 28.7639C26.3264 40.7762 20.7312 52.7886 15.136 64.8009C10.8963 73.9123 6.64977 83.0167 2.41012 92.1212C1.83607 93.3605 1.26203 94.5998 0.681064 95.8391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlogo);
export default __webpack_public_path__ + "static/media/alogo.44d0c872a4da210a3183ebff9074483e.svg";
export { ForwardRef as ReactComponent };